import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUrgencyStandard = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#e5e5e5",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				height: 12,
				rx: 2,
				width: 4,
				x: 10,
				y: 8
			}),
			/* @__PURE__ */ _jsx("rect", {
				height: 16,
				rx: 2,
				width: 4,
				x: 16,
				y: 4
			}),
			/* @__PURE__ */ _jsx("rect", {
				height: 8,
				rx: 2,
				width: 4,
				x: 4,
				y: 12
			})
		]
	})
});
export default SvgUrgencyStandard;
